import { Box, Flex, Heading, Show, Spacer, Stack } from '@chakra-ui/react'
import type { ColorType } from '@twlvxtwlv/types'
import type { ReactNode } from 'react'

interface CardProps {
  backgroundColor?: ColorType | undefined
  border?: boolean | undefined
  children: ReactNode
  subtitle?: ReactNode
  title?: string | undefined | null
  isMinFullHeight?: boolean
}

export function Card({
  backgroundColor = 'white',
  border,
  children,
  subtitle,
  title,
  isMinFullHeight = true,
}: CardProps) {
  return (
    <Stack
      bg={backgroundColor}
      color={backgroundColor === 'white' ? 'black' : 'white'}
      spacing={0}
      w="full"
      minH={isMinFullHeight ? 'full' : undefined}
      align="flex-start"
      justify="flex-start"
      boxShadow="rgb(255, 255, 255) 0px 0px 0px 0px, rgba(51, 65, 85, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.05) 0px 20px 25px -5px, rgba(0, 0, 0, 0.05) 0px 8px 10px -6px"
      rounded={20}
      border={border ? 'rgb(229, 231, 235)' : 'none'}
      borderStyle="solid"
      borderWidth={0}
      p={[6, 6, 6, 6, 8]}
      gap={title ? 4 : 0}
    >
      {title ? (
        <Flex w="full" align="center" gap={[2, 2, 4]}>
          <Heading
            as="h2"
            fontWeight="400"
            fontSize={['sm', 'sm', 'md', 'md', 'xl']}
            textTransform="uppercase"
          >
            {title}
          </Heading>

          <Spacer />

          <Show above="md">
            <Box alignSelf="center">{subtitle}</Box>
          </Show>
        </Flex>
      ) : null}

      <Flex
        w="full"
        minW="full"
        h="full"
        direction="column"
        align="space-between"
        justify="space-between"
      >
        {children}
      </Flex>
    </Stack>
  )
}
